import type { FC } from 'react'

import { ProgressBar, ProgressRoot } from '@app/components/ui/progress'

interface WelcomeProgressBarProps {
  stepCount: number
  currentStep: number
  showProgressBar?: boolean
}

const WelcomeProgressBar: FC<WelcomeProgressBarProps> = ({ stepCount, currentStep, showProgressBar = true }) => {
  if (!showProgressBar) {
    return null
  }

  const progressBarValue = ((currentStep + 1) / stepCount) * 100

  return (
    <ProgressRoot striped animated size="xl" value={progressBarValue}>
      <ProgressBar colorPalette="purple" borderRadius="lg" />
    </ProgressRoot>
  )
}

export default WelcomeProgressBar
